export enum ChannelTypeEnum {
  SMS = 1,
  WHATSAPP = 2,
  INTERNAL = 3,
}

export enum MessageStatusEnum {
  /**
   * Message queued
   */
  PENDING = 0,
  /**
   * Sent to provider
   */
  SENT = 1,
  /**
   * Delivered to recipient
   */
  DELIVERED = 2,
  /**
   * Read by recipient
   */
  READ = 3,
  /**
   * Delivery failed
   */
  FAILED = 4,
  /**
   * Scheduled for delivery
   */
  SCHEDULED = 0,
}

export enum MessageTypeEnum {
  TEXT = 0,
  IMAGE = 5,
  VIDEO = 6,
  FILE = 7,
  LOCATION = 8,
  AUDIO = 9,
  STICKER = 10,
  CONTACT = 11,
}

export enum GroupTypesEnum {
  IMMEDIATE_ACTION = 'Immediate Action',
  LATEST_MESSAGES = 'Latest Messages',
}

export enum ConversationFilterEnum {
  ALL_MESSAGES = 'All Messages',
  MY_MESSAGES = 'My Messages',
  UNREAD = 'Unread',
  UNASSIGNED = 'Unassigned',
  ARCHIVED = 'Archived',
}

export enum ParticipantTypeEnum {
  PHONE_NUMBER = 'phone_number',
  CONTACT = 'contact',
  USER = 'user',
}
